import { createSlice } from '@reduxjs/toolkit/react';
import { jwtDecode } from 'jwt-decode';

export type UserState = {
  username: string;
  accessToken: string;
  refreshToken: string;
  isAuthenticated: boolean;
  locId: string;
  orgId: string;
  userId: string;
  baseUrl: string;
  user: {},
  error: "", // for error message
  loading: boolean,
  isUserLogout: boolean,
  errorMsg: boolean, // for error
};

// Load initial state from localStorage
const loadState = () => {
  try {
    const savedAuth = localStorage.getItem('auth');
    if (savedAuth) {
      return JSON.parse(savedAuth);
    }
  } catch (err) {
    console.error('Error loading auth state:', err);
  }
  return {
    username: '',
    accessToken: '',
    refreshToken: '',
    isAuthenticated: false,
    locId: '',
    orgId: '',
    userId: '',
    baseUrl: '',
    user: {},
    error: "",
    loading: false,
    isUserLogout: false,
    errorMsg: false,
  };
};

const initialState: UserState = loadState();

type DecodedPayloadType = {
  Username: string;
  UserId: string;
  OrgId: string;
  LocId: string;
  BaseUrl: string;
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, refreshToken } = action.payload.data;

      const decodedPayload: DecodedPayloadType = jwtDecode(accessToken);

      state.isAuthenticated = true;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.baseUrl = decodedPayload.BaseUrl;
      state.username = decodedPayload.Username;
      state.locId = decodedPayload.LocId;
      state.orgId = decodedPayload.OrgId;
      state.userId = decodedPayload.UserId;

      // Save to localStorage
      localStorage.setItem('auth', JSON.stringify(state));
    },

    // New action for token refresh
    updateTokens: (state, action) => {
      const { accessToken, refreshToken } = action.payload;
      // console.log('updateTokens', accessToken, refreshToken);
      const decodedPayload: DecodedPayloadType = jwtDecode(accessToken);
      
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.baseUrl = decodedPayload.BaseUrl;
      state.username = decodedPayload.Username;
      state.locId = decodedPayload.LocId;
      state.orgId = decodedPayload.OrgId;
      state.userId = decodedPayload.UserId;

      // Save to localStorage
      localStorage.setItem('auth', JSON.stringify(state));
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.accessToken = '';
      state.refreshToken = '';
      state.username = '';
      state.locId = '';
      state.orgId = '';
      state.userId = '';
      state.baseUrl = '';
      state.user = {};
      
      // Clear from localStorage
      localStorage.removeItem('auth');
    },
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      
      // Save to localStorage
      localStorage.setItem('auth', JSON.stringify(state));
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
      
      // Clear from localStorage
      localStorage.removeItem('auth');
    },
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    }
  },
});

export const { setCredentials, updateTokens, logout, apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag } = authSlice.actions;

export default authSlice.reducer;
